import { FC, PropsWithChildren, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectSellers } from '@savgroup-front-common/core/domains/sellers/selectors';
import { createGenericContext } from '@savgroup-front-common/core/helpers';
import { Seller } from '@savgroup-front-common/types';

export interface AppContextArgs {
  isIframeContext: boolean;
  onIframePageMount: () => void;
  onIframePageUnmount: () => void;
  selectedSeller: Seller;
}

const [useAppContext, AppProvider] = createGenericContext<AppContextArgs>();

const AppContextProvider: FC<PropsWithChildren<Record<never, never>>> = ({
  children,
}) => {
  const [isIframeContext, setIsIframeContext] = useState(false);
  const sellers = useSelector(selectSellers);

  const firstSeller = sellers[0];

  const onIframePageMount = useCallback(() => {
    setIsIframeContext(true);
  }, []);
  const onIframePageUnmount = useCallback(() => {
    setIsIframeContext(false);
  }, []);

  return (
    <AppProvider
      value={{
        isIframeContext,
        onIframePageMount,
        onIframePageUnmount,
        selectedSeller: firstSeller,
      }}
    >
      {children}
    </AppProvider>
  );
};

export { AppContextProvider, useAppContext };
